module.exports = __webpack_public_path__ + "img/NC_Headshot.2e01dd91.png";